<template>
  <div>
    <div
      class="modal fade"
      id="modal-activities"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered custom-modal-width"
        role="document"
      >
        <div class="modal-content">
          <!-- <div class="modal-header">
            <h5 class="modal-title" id="ModalTitle1">
              {{ $t("other-tasks") }}
            </h5>
            <div
              class="ml-auto pointer"
              data-dismiss="modal"
              aria-label="Close"
            >
              <i class="fa-solid fa-xmark fa-xl text-darkdark"></i>
            </div>
          </div> -->
          <div class="modal-body">
            <div class="d-flex justify-content-end">
              <i class="fa-solid fa-xmark pointer" @click="closeModal()"></i>
            </div>
            <div class="d-flex justify-content-center flex-wrap">
              <!-- <SquareIconBtn
                v-for="i in 9"
                class="mx-1"
                :title="'actitivy'"
                :iconIndex="i"
              ></SquareIconBtn> -->
              <div
                class="row col-12 col-sm-12"
                v-if="selectActivity === 'english'"
              >
                <a
                  v-for="i in isAppDomain ? 5 : 4"
                  class="col-12 col-sm-3 py-2"
                  @click="goExternalLink(i)"
                >
                  <img :src="getActivityImage(i)" class="rounded img-fluid" />
                </a>
              </div>
              <div
                class="row col-12 col-sm-12 d-flex justify-content-center"
                v-else
              >
                <a
                  v-for="i in [2, 3]"
                  class="col-12 col-sm-4 py-2"
                  @click="goExternalLink(i)"
                >
                  <img :src="getActivityImage(i)" class="rounded img-fluid" />
                </a>
              </div>
            </div>
          </div>
          <!-- <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-outline"
              data-dismiss="modal"
            >
              {{ $t("close") }}
            </button>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import SquareIconBtn from "./Base/SquareIconBtn.vue";
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import { useUserInfoStore } from "@/store/modules/userInfo";
const userInfo = useUserInfoStore();
const { locale, t } = useI18n({
  inheritLocale: true,
});

const props = defineProps({
  selectActivity: String,
});

// 檢查 VITE_MSU_DOMAIN 環境變數是否為 'app'
const isAppDomain = computed(() => {
  return import.meta.env.VITE_MSU_DOMAIN === "app";
});

const closeModal = () => {
  $(`#modal-activities`).modal("hide");
};

const getActivityImage = (index) => {
  if (props.selectActivity === "english") {
    return new URL(`../assets/img/activity_icon/e${index}.png`, import.meta.url)
      .href;
  } else if (props.selectActivity === "relax") {
    return new URL(
      `../assets/img/activity_icon/game${index}.png`,
      import.meta.url
    ).href;
  }
};

const $goPage = inject("$goPage");

const goExternalLink = (index) => {
  const currentLang = locale.value;
  $("#modal-activities").modal("hide");
  if (props.selectActivity === "english") {
    if (index === 1) {
      $goPage(`/msu/phrasal-verb?LANG=${currentLang}`);
    } else if (index === 2) {
      $goPage(`/msu/daily-conversation?LANG=${currentLang}`);
    } else if (index === 4) {
      let token = localStorage.getItem("token");
      let link = `https://ai-edu.mangosteems.com/ai_speak/?lang=${currentLang}&auth=${token}?userid=${userInfo.student.stuID}`;
      window.open(link, "_blank");
      // let token = localStorage.getItem("token");
      // let link = `https://ai-voc.igroupnet.com/?auth=${token}&LANG=${currentLang}&domain=${
      //   import.meta.env.VITE_MSU_DOMAIN
      // }&practiceid=${practice_id}`;
      // window.open(link, "_blank");
    } else if (index === 3) {
      $goPage(`/msu/practice-words`);
    } else if (index === 5) {
      $goPage(`/msu/english-central`);
    }
  } else if (props.selectActivity === "relax") {
    if (index === 1) {
      // 處理 index 1 的情況
    } else if (index === 2) {
      let token = localStorage.getItem("token");
      let link = `https://whacamole.mangosteems.com/?auth=${token}&LANG=${currentLang}`;
      window.open(link, "_blank");
    } else if (index === 3) {
      let token = localStorage.getItem("token");
      let link = `https://cardgame.mangosteems.com/?auth=${token}&LANG=${currentLang}`;
      window.open(link, "_blank");
    }
  }
};
</script>
<style lang="scss" scoped>
.custom-modal-width {
  width: 90%; /* 使用百分比寬度 */
  max-width: 800px; /* 設置最大寬度，避免在大螢幕上過寬 */
  margin: 1.75rem auto;
}

/* 在小螢幕上調整寬度 */
@media (max-width: 576px) {
  .custom-modal-width {
    width: 95%;
    margin: 1rem auto;
  }
}
</style>
